import { Checkbox as CheckboxInput } from "@blueprintjs/core";
import { ICheckbox } from "../../types";
import { IInputProps } from "../types";
import { doHidden, doDisabled } from "../../utils";
import Validate, { renderInfo } from "components/Template/Validate";
import Override from "components/Template/Override";
import ChangeHighlight from "components/Template/ChangeHighlight";
import "./Checkbox.scss";

export interface ICheckboxProps extends IInputProps {
  template: ICheckbox;
}

const Checkbox = (props: ICheckboxProps) => {
  const { template, model, mutators, metadata } = props;
  const { getValue, handleChange } = mutators;

  if (doHidden(props)) {
    if (!metadata.hiddenInput.includes(template.name)) {
      metadata.hiddenInput.push(template.name);
    }
    return null;
  } else {
    if (metadata.hiddenInput.includes(template.name)) {
      metadata.hiddenInput = metadata.hiddenInput.filter((i) => i === template.name);
    }
  }
  const disabled = doDisabled(props);

  const currentValue = getValue(template.name) as boolean;
  const storedValue = mutators.getStoredValue ? mutators.getStoredValue(template.name) : undefined;
  const hasChanged = storedValue !== undefined && storedValue !== currentValue;

  const handleUndo = () => {
    if (mutators.setStoredValue) {
      handleChange && handleChange(template.name, storedValue as boolean);
    }
  };

  const handleKeep = () => {
    if (mutators.setStoredValue) {
      mutators.setStoredValue(template.name, currentValue);
    }
  };

  return (
    <Validate {...props}>
      <ChangeHighlight
        changed={hasChanged}
        onUndo={hasChanged ? handleUndo : undefined}
        onKeep={hasChanged ? handleKeep : undefined}
        changePath={mutators.getPath(template.name)}
      >
        <div className="checkbox">
          <CheckboxInput
            key={template.name}
            id={template.name}
            checked={currentValue}
            {...(handleChange
              ? {
                  onChange: () => handleChange(template.name, !currentValue),
                }
              : { readOnly: true })}
            disabled={disabled}
          >
            {template.label}
            {template.description ? renderInfo(template.description, model) : undefined}
          </CheckboxInput>
          <Override {...props} />
        </div>
      </ChangeHighlight>
    </Validate>
  );
};

export default Checkbox;
